import { render, staticRenderFns } from "./GeneralAttributePicker.vue?vue&type=template&id=1fab2f47"
import script from "./GeneralAttributePicker.vue?vue&type=script&lang=js"
export * from "./GeneralAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./GeneralAttributePicker.vue?vue&type=style&index=0&id=1fab2f47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports